import { useEffect, useRef } from "react";
import { useIntersectionObserver } from "web/react/hooks/use-intersection-observer/use-intersection-observer";
import analytics from "web/script/analytics/analytics";

export function useSectionImpression(label: string, order: number): React.RefObject<HTMLElement> {
    const sectionRef = useRef<HTMLElement>(null);
    const hasFired = useRef(false);
    const [isVisible] = useIntersectionObserver({ once: true, threshold: 0.3 }, sectionRef);

    useEffect(() => {
        if (isVisible && !hasFired.current) {
            hasFired.current = true;
            analytics.event({
                category: "partners_section",
                action: "impression",
                label,
                customData: { order },
            });
        }
    }, [isVisible, label, order]);

    return sectionRef;
}
